<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="活动城市">
        <el-select ref="cityBox" v-model="search.city" placeholder="城市">
          <el-option label="全国" value="" />
          <el-option v-for="item in citySelectVO" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="活动时间">
        <el-date-picker ref="dateBox" v-model="search.beginTime" type="date" placeholder="选择日期" format-date />
      </el-form-item>
      <el-form-item label="活动状态">
        <el-select ref="statusBox" v-model="search.status" placeholder="选择活动状态">
          <el-option label="全部" value="" />
          <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item class="search-form-item">
        <el-input v-model="search.name" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="activity-preorder operation-bar">
      <el-button size="small" type="primary" @click="releaseActivities">
        <svg-icon icon-class="public" />
        立即发布
      </el-button>
      <el-button size="small" type="primary" @click="openRegistration">
        <svg-icon icon-class="register" />
        开放报名
      </el-button>
      <el-button size="small" type="primary" class="upload-button" @click="getUploadList">
        <img src="@/assets/images/upload-icon.png" alt="" class="button-img">
        <span>上传个人榜单</span>
      </el-button>
      <el-button size="small" type="primary" class="upload-button" @click="getTeamUploadList">
        <img src="@/assets/images/upload-icon.png" alt="" class="button-img">
        <span>上传团队榜单</span>
      </el-button>
    </div>
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed />
      <el-table-column prop="id" label="活动ID" width="100" fixed />
      <el-table-column prop="name" label="活动标题" width="100" />
      <el-table-column prop="type" label="类型" width="120">
        <template v-slot="scope">
          <div v-if="scope.row.uaraEventTypeId === eventType[scope.row.uaraEventTypeId - 1 ].id">{{ eventType[scope.row.uaraEventTypeId - 1 ].name }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="isTeamEvent" label="报名方式" min-width="100">
        <template v-slot="scope">
          <div v-if="scope.row.isTeamEvent === 0">个人</div>
          <div v-else-if="scope.row.isTeamEvent === 1">组队</div>
          <div v-else>其他</div>
        </template>
      </el-table-column>
      <el-table-column prop="city" label="活动城市" />
      <el-table-column prop="status" label="活动状态" width="auto" min-width="100">
        <template v-slot="scope">
          <el-tag v-if="scope.row.status === 0" type="success" size="mini">已发布</el-tag>
          <el-tag v-if="scope.row.status === 1" class="el-tag--yellow" size="mini">草稿</el-tag>
          <!-- <el-tag v-if="scope.row.status === 2" class="el-tag--purple" size="mini">审核中</el-tag> -->
          <!-- <el-tag v-if="scope.row.status === 3" class="el-tag--blue" size="mini">待发布</el-tag> -->
          <el-tag v-if="scope.row.status === 4" class="el-tag--red" size="mini">开放报名中</el-tag>
          <el-tag v-if="scope.row.status === 5" class="el-tag--end" size="mini">已结束</el-tag>
          <el-tag v-if="scope.row.status === 6" class="el-tag--gray" size="mini">报名截止</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="beginTime" label="活动开始日期" width="auto" min-width="100">
        <template #default="{row}">
          {{ $moment(row.beginTime).format('YYYY/MM/DD') || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="haveSignedUpNum" label="报名人数/队伍数" width="auto" min-width="100" />
      <el-table-column fixed="right" width="700px" label="操作">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="exportEnrollmentList(row)">报名名单下载</el-button>
          <el-button size="small" type="text" class="link-color" @click="exportIdentityCardList(row)">身份证信息表</el-button>
          <el-button v-if="row.status === 6 && row.uaraEventTypeId == 1 && row.isTeamEvent === 0 && row.trainingCourseProgress == 0 && row.isSecondaryScreening === 1" size="small" type="text" class="link-color" @click="trainingClassUserList(row)">上传培训班用户名单</el-button>
          <el-button v-if="row.status === 6 && row.uaraEventTypeId == 1 && row.isTeamEvent === 1 && row.trainingCourseProgress == 0 && row.isSecondaryScreening === 1" size="small" type="text" class="link-color" @click="trainingClassTeamList(row)">上传培训班团队名单</el-button>
          <el-button v-if="row.status === 6 && row.uaraEventTypeId == 5 && row.trainingCourseProgress == 0&& row.isTeamEvent === 0" size="small" type="text" class="link-color" @click="reexamineList(row)">上传万米精英赛用户名单</el-button>
          <el-button v-if="row.status === 6 && row.uaraEventTypeId == 5 && row.trainingCourseProgress == 0&& row.isTeamEvent === 1" size="small" type="text" class="link-color" @click="reexamineTeamList(row)">上传万米精英赛团队名单</el-button>
          <el-popover placement="bottom" width="148" style="margin:0 10px" trigger="click" :popper-options="{ removeOnDestroy: true }">
            <div style="text-align:center">
              <img :ref="`downLoadImg${row.id}`" src="" alt="" style="width:100%;">
              <el-button size="small" type="text" class="link-color" @click="downQrCode(row)">下载二维码</el-button>
            </div>
            <el-button slot="reference" size="small" type="text" class="link-color" @click="getErcode(row)">签到二维码</el-button>
          </el-popover>
          <el-button size="small" type="text" class="link-color" @click="handleShare(row)">分享</el-button>
          <el-button slot="reference" size="small" type="text" class="link-color" @click="uploadActivityPhoto(row)">上传活动相册</el-button>
          <el-button v-if="row.status === 6 && row.uaraEventTypeId === 3 && row.trainingCourseProgress === 0 && row.isSecondaryScreening === 1 && row.isTeamEvent === 0" slot="reference" size="small" type="text" class="link-color" @click="uploadRoutineRunning(row)">上传常规跑用户名单</el-button>
          <el-button v-if="row.status === 6 && row.uaraEventTypeId === 3 && row.trainingCourseProgress === 0 && row.isSecondaryScreening === 1 && row.isTeamEvent === 1" slot="reference" size="small" type="text" class="link-color" @click="uploadRoutineRunningTeam(row)">上传常规跑团队名单</el-button>
          <el-button size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="text" class="link-color" @click="remove(row)">删除</el-button>
          <el-button v-if="row.status === 1" size="small" type="text" class="link-color" @click="release(row)">发布</el-button>
          <el-button v-if="row.status === 0" size="small" type="text" class="link-color" @click="postOfflineTask(row.id)">下架</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="fixed-below" :page-size="currentPage.limit" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage.current" :total="currentPage.total" layout="total, prev, pager, next, sizes" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    <!-- 弹窗 -->
    <el-dialog v-if="importDialogShow" :visible="importDialogShow" :title="dialogTitle" custom-class="share-wrapper" @close="handleCloseImport">
      <div class="upload-wrapTop">
        <div class="tips">下载导入模板，根据模板完善内容</div>
        <div v-if=" dialogTitle==='上传个人榜单'|| dialogTitle === '上传团队榜单' " class="coupon_tip" @click="downloadFileTemplate('上传榜单')">
          <i class="el-icon-document" />下载文件模板
        </div>
        <div v-else class="coupon_tip" @click="downloadFileTemplate('')">
          <i class="el-icon-document" />下载文件模板
        </div>
      </div>
      <div class="upload-wrap">
        <div v-if="dialogTitle==='上传个人榜单' || dialogTitle === '上传团队榜单' " class="tips">
          <span style="margin-right:10px">榜单名称</span>
          <el-select ref="statusBox" v-model="listName" placeholder="选择活动状态" style="height:34px">
            <el-option v-for="(item,index) in activityStatus" :key="index" :label="item" :value="index" />
          </el-select>
        </div>
        <div v-else class="tips">上传完善好的表格，仅支持上传*.xls、*.xlsx格式</div>
        <el-upload class="upload-box" drag action="" :show-file-list="false" :on-change="handlePushUploader" :auto-upload="false">
          <div>
            <div style="height:50px;">
              <svg-icon icon-class="xls" style="width: 50px; height: 50px;" />
            </div>
            <el-button v-if="!classExcel" size="small">选择文件</el-button>
            <template v-else>
              <div class="file">{{ classExcel.name }}</div>
              <el-button size="small">重新选择</el-button>
            </template>
          </div>
        </el-upload>
      </div>
      <div class="flex btns">
        <el-button type="info" @click="handleCloseImport">取消</el-button>
        <el-button type="primary" @click="uploadSubmit">保存</el-button>
      </div>
    </el-dialog>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
    <!-- 分享弹窗 -->
    <el-dialog v-if="showShare" :visible.sync="showShare" title="选择需要分享的链接类型" custom-class="share-wrapper-box" @close="handleResetShare">
      <el-form ref="shareBox" class="share-form" :model="shareForm" :rules="shareRules">
        <el-form-item label="是否加参" prop="isHaveParameter">
          <el-radio v-model="shareForm.isHaveParameter" :label="1" @change="handleHideTabs">不需要</el-radio>
          <el-radio v-model="shareForm.isHaveParameter" :label="0" @change="handleHideTabs">需要</el-radio>
        </el-form-item>
        <el-form-item label="分享方式" prop="shareWay">
          <el-select v-model="shareForm.shareWay" placeholder="请选择分享方式" style="width: 150px;" @change="handleChangeShareWay">
            <el-option v-for="item in shareList" :key="item.id" :label="item.value" :value="item.id" />
          </el-select>
        </el-form-item>
        <template v-if="!shareForm.isHaveParameter">
          <div class="info-wrapper">
            <div class="split" />
            <div class="info-title">基础信息</div>
            <el-form-item label="描述文字" prop="description">
              <el-input v-model="shareForm.description" placeholder="请输入描述文字" style="width: 407px" />
            </el-form-item>
            <div style="display: flex">
              <el-form-item label="活动名称" style="margin-right: 40px;">
                <el-input v-model="shareForm.activityName" disabled placeholder="请输入活动名称" style="width: 150px" />
              </el-form-item>
              <el-form-item label="活动类型" prop="activityType">
                <el-select v-model="shareForm.activityType" placeholder="请选择分享方式" style="width: 150px;" @change="handleChangeActivityType">
                  <el-option v-for="item in shareSelect.activityType" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </div>
            <div class="share-form-detail">
              <el-form-item label="活动时间:">
                <span :title="shareForm.activeTime">{{ shareForm.activeTime || '' }}</span>
              </el-form-item>
              <el-form-item label="活动城市:">
                <span :title="shareForm.city">{{ shareForm.city || '' }}</span>
              </el-form-item>
              <el-form-item label="活动门店:">
                <span :title="shareForm.addressName">{{ shareForm.addressName || '' }}</span>
              </el-form-item>
            </div>

          </div>
          <div class="info-wrapper">
            <div class="split" />
            <div class="info-title">参数选择</div>
            <div style="display: flex">
              <el-form-item label="Channel" class="chanel" prop="utmChannel">
                <el-select v-model="shareForm.utmChannel" placeholder="请选择" style="width: 150px;" @change="handleRelationSource">
                  <el-option v-for="item in shareSelect.utmChannel" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item label="Source" class="source" prop="utmSource">
                <el-select v-model="shareForm.utmSource" placeholder="请选择" style="width: 150px; margin-right: 10px;" @change="handleRelationChannel">
                  <el-option v-for="item in shareSelect.utmSource" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                <el-input v-if="handleFindOther()" v-model="shareForm.utmContent" placeholder="请输入" style="width: 120px" />
              </el-form-item>
            </div>
            <div style="display: flex">
              <el-form-item label="UTM campaign" class="utmCampaign" prop="utmCampaign">
                <el-input v-model="shareForm.utmCampaign" placeholder="请输入活动名称" style="width: 150px" />
              </el-form-item>
              <el-form-item label="UTM media">
                <el-select v-model="shareForm.utmMedium" placeholder="请选择" style="width: 150px;" @change="handleChangeShareWay">
                  <el-option v-for="item in shareSelect.utmMedium" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </div>
          </div>
        </template>
        <el-form-item class="share-form-btn">
          <el-button type="primary" @click="handleShowTabs">生成链接/二维码</el-button>
        </el-form-item>
      </el-form>
      <template v-if="showTabs && !Object.values(shareData).some(item=>!item)">
        <el-tabs v-model="activeTab" class="tabs-wrapper" style="padding-left: 30px; padding-right: 29px">
          <el-tab-pane :label="`${shareList[shareForm.shareWay].value}二维码`" name="code">
            <div class="code-wrapper">
              <div class="code-img">
                <img ref="shareDataImg" :src="shareForm.shareWay===0 ?shareData.miniProgramQrCode : shareData.h5QrCode" alt="">
              </div>
              <el-button type="primary" @click="handleDownQrCode">下载二维码</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="`${shareList[shareForm.shareWay].value}链接`" name="link">
            <div class="link-wrapper">
              <div class="link-content">
                <p ref="copyLink" class="content">
                  {{ shareForm.shareWay===0 ? shareData.miniProgramLinks :shareData.h5Links }}
                </p>
              </div>
              <el-button type="primary" @click="copyLink">复制链接</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { formatDate, formatDate1 } from '@/filters';
import { getFileType, imatateDownloadByA } from '@/common/js/util';
import Dialog from '@/components/Dialog';
import FunctionUtils from '@/utils/functionUtils';

export default {
  components: { Dialog },
  data() {
    const statusList = [
      { id: 0, value: '已发布' },
      { id: 1, value: '草稿' },
      // { id: 2, value: '审核中' },
      // { id: 3, value: '待发布' },
      { id: 4, value: '开放报名中' },
      { id: 6, value: '报名截止' },
      { id: 5, value: '已结束' },
    ];
    return {
      search: {
        city: "",
        name: "",
        beginTime: "",
        status: "",
      },
      searchSubmitted: {},
      statusList: statusList,
      activityStatus: [],
      eventType: [],
      list: [],
      currentPage: {
        current: 1,
        limit: 10,
        total: 0,
      },
      activityIds: [],
      importDialogShow: false, // 上传榜单弹窗开关
      dialogTitle: '上传榜单', // 弹窗名称
      listName: 0,
      enter: -1,
      classExcel: null,
      formDialogShow: false,
      information: {},
      showShare: false, // 分享弹窗
      showTabs: false,
      activeTab: 'code',
      shareForm: {
        isHaveParameter: 1,
        shareWay: 0,
        activityId: '',
        activityName: '',
        activityType: null,
        description: '',
        activeTime: '',
        city: '',
        addressName: '',
        utmChannel: null,
        utmSource: null,
        utmMedium: null,
        utmCampaign: '',
        utmContent: '',
      },
      shareData: {
        h5Links: '',
        h5QrCode: '',
        miniProgramLinks: '',
        miniProgramQrCode: '',
      },
      shareSelect: {
        activityType: [],
        utmChannel: [],
        utmContent: [],
        utmMedium: [],
        utmSource: [],
      },
      shareList: [
        { id: 0, value: '小程序' },
        // { id: 1, value: 'H5' },
      ],
      shareRules: {
        isHaveParameter: [{ required: true, message: '请选择是否需要加参', trigger: 'change' }],
        shareWay: [{ required: true, message: '请选择分享方式', trigger: 'change' }],
      },
    };
  },
  computed: {
    ...mapState('activity', ['citySelectVO']),
  },
  beforeRouteLeave(to, from, next) {
    const list = ['/activity/uara/edit', '/activity/uara/add'];
    if (!list.includes(to.path)) {
      this.enter = 0;
      this.searchSubmitted = {};
      this.search = {
        city: '',
        id: '',
        name: '',
        beginTime: '',
        status: '',
      };
      this.pageNum = 1;
    }
    next();
  },
  activated() {
    this.enter += 1;
    if (this.enter) {
      this.classExcel = null;
      this.searchSubmit();
    }
  },
  mounted() {
    this.getListType();
    this.getEventType();
    this.getList();
    this.fetchBuriedChannel();
  },
  methods: {
    getEventType() {
      this.$Api.uara.getUaraTypeList().then(res => {
        this.eventType = res;
      });
    },
    getListType() {
      this.$Api.uara.getLeaderBoardName().then(res => {
        this.activityStatus = res;
      });
    },
    getList() {
      this.$Api.uara.getUaraList({ ...this.currentPage, ...this.searchSubmitted }).then(res => {
        this.currentPage.total = res.total;
        this.list = res.data;
      });
    },
    // 新增
    add() {
      this.$router.push({ path: '/activity/uara/add' });
    },
    // 查询
    searchSubmit() {
      this.searchSubmitted = {};
      Object.keys(this.search).forEach(key => {
        if (key === 'beginTime') {
          this.searchSubmitted['beginTime'] = formatDate(this.search[key]);
        } else {
          this.searchSubmitted[key] = this.search[key];
        }
      });
      this.currentPage.current = 0;
      this.getList();
    },
    // 重置
    reset() {
      this.searchSubmitted = {};
      this.search = {
        city: '',
        id: '',
        name: '',
        beginTime: '',
        status: '',
      };
      this.currentPage.current = 1;
      this.getList();
    },
    // 立即发布
    releaseActivities() {
      this.$Api.uara.openUaraList(this.activityIds).then(res => {
        this.$message.success('发布成功');
        this.getList();
      });
    },
    // 开放报名
    openRegistration() {
      this.$Api.uara.openRegistration(this.activityIds).then(res => {
        this.$message.success('开放报名成功');
        this.getList();
      });
    },
    // 上传活动相册
    uploadActivityPhoto(row) {
      this.$router.push({ path: '/activity/uara/photo-album-upload', query: row });
    },
    exportEnrollmentList(row) {
      this.$Api.uara.exportEnrollmentList(row.id).then(res => {
        if (!res) {
          this.$message.error('该UARA活动暂无报名人员');
        } else {
          this.$message.success('导出成功');
        }
      });
    },
    exportIdentityCardList(row) {
      this.$Api.uara.exampleExportTheIDCardInformationTable(row.id).then(res => {
        if (!res) {
          this.$message.error('该UARA活动暂无报名人员');
        } else {
          this.$message.success('导出成功');
        }
      });
    },
    getUploadList(row) {
      this.currentID = row.id;
      this.importDialogShow = true;
      this.dialogTitle = '上传个人榜单';
    },
    getTeamUploadList(row) {
      this.currentID = row.id;
      this.importDialogShow = true;
      this.dialogTitle = '上传团队榜单';
    },
    reexamineList(row) {
      this.currentID = row.id;
      this.importDialogShow = true;
      this.dialogTitle = '上传万米精英赛用户名单';
    },
    reexamineTeamList(row) {
      this.currentID = row.id;
      this.importDialogShow = true;
      this.dialogTitle = '上传万米精英赛团队名单';
    },
    trainingClassUserList(row) {
      this.currentID = row.id;
      this.importDialogShow = true;
      this.dialogTitle = '上传培训班用户名单';
    },
    trainingClassTeamList(row) {
      this.currentID = row.id;
      this.importDialogShow = true;
      this.dialogTitle = '上传培训班团队名单';
    },
    uploadRoutineRunning(row) {
      this.currentID = row.id;
      this.importDialogShow = true;
      this.dialogTitle = '上传常规跑用户名单';
    },
    uploadRoutineRunningTeam(row) {
      this.currentID = row.id;
      this.importDialogShow = true;
      this.dialogTitle = '上传常规跑团队名单';
    },
    // 下载二维码
    downQrCode(row) {
      // 创建a链接下载
      const link = document.createElement('a');
      link.href = this.$refs[`downLoadImg${row.id}`].src;
      link.download = `${row.name}.png`;
      link.target = '_blank';
      link.click();
    },
    // 签到二维码
    getErcode(row) {
      this.$Api.uara.searchUaraItemQrcode(row.id).then((res) => {
        this.$refs[`downLoadImg${row.id}`].src = res;
      });
    },
    fetchBuriedChannel() {
      this.$Api.activity.buriedChannelSelect().then(res => {
        if (res) {
          if (res.utmChannel && res.utmChannel.length) {
            res.utmChannel = FunctionUtils.objectReset(res.utmChannel, 'name');
          }
          if (res.utmSource && res.utmSource.length) {
            res.utmSource.push({
              "id": -99,
              "parentId": null,
              "type": 1,
              "name": "其他",
              "remark": "",
            });
          }
          this.shareSelect = res;
        }
      });
    },
    handleHideTabs(val) {
      this.handleChangeShareRules();
      this.showTabs = false;
    },
    // 分享
    handleShare(row) {
      console.log('row =====>', row);
      const activeTime = `${formatDate1(row.beginTime)} - ${formatDate1(row.endTime)}`;
      this.currentID = row.id;
      this.shareForm = {
        ...this.shareForm,
        activityId: row.id,
        activityName: row.name,
        activeTime: activeTime,
        city: row.city,
        addressName: row.addressName,
      };
      this.showShare = true;
    },
    handleRelationChannel(val) {
      this.shareForm.utmContent = '';
      if (!this.shareForm.utmChannel && val === -99) {
        this.shareForm.utmSource = null;
        this.$message.warning('请先选择Channel，再选择其他');
        return;
      }
      if (val === -99) return;
      this.shareForm.utmChannel = null;
      this.$Api.activity.buriedChannelSelectTwoStageLinkage({
        utmSourceId: val,
      }).then(res => {
        if (res && res.length) {
          this.shareForm.utmChannel = this.shareSelect.utmChannel.find(item => item.name === res[0].name).id;
        }
      });
    },
    handleFindOther() {
      if (!this.shareForm.utmSource) return false;
      const { name } = this.shareSelect.utmSource.find(item => item.id === this.shareForm.utmSource);
      return name === '其他';
    },
    //  Channel关联Source
    handleRelationSource(val) {
      this.shareForm.utmContent = '';
      this.shareForm.utmSource = null;
      this.$Api.activity.buriedChannelSelectTwoStageLinkage({
        utmChannelId: val,
      }).then(res => {
        if (res && res.length) {
          this.shareSelect.utmSource = [...res, {
            "id": -99,
            "parentId": null,
            "type": 1,
            "name": "其他",
            "remark": "",
          }];
          this.$refs.shareBox.validateField('utmSource');
        }
      });
    },
    // 改变活动类型
    handleChangeActivityType(val) {
      this.$Api.activity.buriedChannelCampaign({
        activityId: this.shareForm.activityId,
        activityType: val,
      }).then(res => {
        if (res) {
          this.shareForm.utmCampaign = res;
          this.$refs.shareBox.validateField('utmCampaign');
        }
      });
    },
    // 复制活动分享链接
    copyLink() {
      if (!this.$refs.copyLink && !this.$refs.copyLink.innerText) return;
      navigator.clipboard.writeText(this.$refs.copyLink.innerText).then(() => {
        this.$message.success('复制成功');
      });
    },
    // 下载活动分享带参/不带参二维码
    handleDownQrCode() {
      if (!this.$refs.shareDataImg || !this.$refs.shareDataImg.src) return;
      imatateDownloadByA(this.$refs.shareDataImg.src, `${this.shareForm.name || '活动分享'}.png`);
    },
    // 改变分享方式
    handleChangeShareWay() {
      this.activeTab = 'code';
      this.handleHideTabs();
    },
    // 生成二维码，链接
    handleShowTabs() {
      const params = this.handleDealParams();
      console.log(params);
      this.$refs.shareBox.validate(valid => {
        if (valid) {
          // 不需要带参
          if (this.shareForm.isHaveParameter === 1) {
            this.$Api.activity.buriedChannel({
              activityId: this.currentID,
              isHaveParameter: this.shareForm.isHaveParameter,
              objectType: 13, // 13是uara
            }).then(res => {
              res && (this.shareData = res);
              this.showTabs = true;
            });
          } else {
            const params = this.handleDealParams();
            this.$Api.activity.buriedChannel(params).then(res => {
              res && (this.shareData = res);
              this.showTabs = true;
            });
          }
        }
      });
    },
    // 动态改变校验规则
    handleChangeShareRules() {
      if (this.shareForm.isHaveParameter === 1) {
        this.shareRules = {
          isHaveParameter: [{ required: true, message: '请选择是否需要加参', trigger: 'change' }],
          shareWay: [{ required: true, message: '请选择分享方式', trigger: 'change' }],
        };
      } else {
        this.shareRules = {
          ...this.shareRules,
          description: [{ required: true, message: '请输入描述文字', trigger: 'blur' }],
          activityType: [{ required: true, message: '请选择活动类型', trigger: 'change' }],
          utmChannel: [{ required: true, message: '请选择Channel', trigger: 'change' }],
          utmSource: [{
            required: true, validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请选择Source'));
              }
              const obj = this.shareSelect.utmSource.find(item => item.id === value);
              if (obj && obj.name === '其他' && !this.shareForm.utmContent) {
                callback(new Error('请输入Source'));
              } else {
                callback();
              }
            }, trigger: 'change',
          }],
          utmCampaign: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        };
      }
    },
    // 处理活动带参
    handleDealParams() {
      const defaultParams = {
        objectType: 13, // 5是uara
        activityId: this.shareForm.activityId,
        activityName: this.shareForm.activityName,
        isHaveParameter: this.shareForm.isHaveParameter,
      };
      if (this.shareForm.activityType) {
        defaultParams['activityType'] = this.shareForm.activityType;
      }
      if (this.shareForm.description) {
        defaultParams['description'] = this.shareForm.description;
      }
      if (this.shareForm.utmCampaign) {
        defaultParams['utmCampaign'] = this.shareForm.utmCampaign;
      }
      if (this.shareForm.utmChannel && this.shareSelect.utmChannel && this.shareSelect.utmChannel.length) {
        const { name } = this.shareSelect.utmChannel.find(item => item.id === this.shareForm.utmChannel);
        name && (defaultParams['utmChannel'] = name);
      }
      if (this.shareForm.utmSource && this.shareSelect.utmSource && this.shareSelect.utmSource.length) {
        const { name } = this.shareSelect.utmSource.find(item => item.id === this.shareForm.utmSource);
        if (name === '(空)') {
          defaultParams['utmSource'] = null;
        } else if (name === '其他') {
          defaultParams['utmSource'] = this.shareForm.utmContent;
        } else {
          defaultParams['utmSource'] = name;
        }
      }
      if (this.shareForm.utmMedium && this.shareSelect.utmMedium && this.shareSelect.utmMedium.length) {
        const { name } = this.shareSelect.utmMedium.find(item => item.id === this.shareForm.utmMedium);
        defaultParams['utmMedium'] = name;
      }
      return defaultParams;
    },
    // 重置分享表单
    handleResetShare() {
      this.shareData = {
        h5Links: '',
        h5QrCode: '',
        miniProgramLinks: '',
        miniProgramQrCode: '',
      };
      this.shareForm = {
        isHaveParameter: 1,
        shareWay: 0,
        activityId: '',
        activityName: '',
        activityType: null,
        description: '',
        activeTime: '',
        city: '',
        addressName: '',
        utmChannel: null,
        utmSource: null,
        utmMedium: null,
        utmCampaign: '',
        utmContent: '',
      };
      this.activeTab = 'code';
      this.handleChangeShareRules();
    },
    // 编辑
    edit(row) {
      if ([0, 2, 4].indexOf(row.status) !== -1) {
        this.formDialogShow = true;
        this.currentID = row.id;
        const subTitle = row.status === 0 ? '活动已发布，编辑将会更新活动信息，是否继续？' : '活动已开放报名，编辑将会更新活动信息，是否继续？';
        this.information = {
          operation: 'edit',
          icon: 'warn',
          subTitle: subTitle,
        };
      } else {
        this.$router.push({ path: '/activity/uara/edit', query: { id: row.id } });
      }
    },
    // 删除
    remove(row) {
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '删除后小程序用户将无法查看该活动，请确认是否删除',
        // subTitle: `是否确认删除活动ID为“${row.id}”的数据项？`,
      };
      this.formDialogShow = true;
    },
    // 发布
    release(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'release',
        icon: 'warn',
        subTitle: `是否确认发布活动ID为“${this.currentID}”的数据项？`,
      };
    },
    // 下架
    postOfflineTask(id) {
      this.formDialogShow = true;
      this.currentID = id;
      this.information = {
        operation: 'offline',
        icon: 'warn',
        subTitle: `是否确认下架活动ID为“${this.currentID}”的数据项？`,
      };
    },
    submitSucces(operation) {
      if (operation === 'delete') {
        this.$Api.uara.delUaraList(this.currentID).then(() => {
          this.$message.success('删除成功');
          this.currentPage.current = (this.currentPage.current -= this.list.length === 1 && 1) ? 1 : this.currentPage.current;
          this.getList();
        });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/activity/uara/edit', query: { id: this.currentID } });
      } else if (operation === 'release') {
        this.$Api.uara.openUaraList([this.currentID]).then(res => {
          this.$message.success('发布成功');
          this.getList();
        });
      } else if (operation === 'offline') {
        this.$Api.uara.closeUaraList([this.currentID]).then(res => {
          this.$message.success('下架成功');
          this.getList();
        });
      }
    },
    handlePushUploader(file) {
      if (getFileType(file.raw.name) !== 'excel') {
        this.$message.error('导入失败，请选择Excel文件');
        return;
      }
      this.classExcel = file.raw;
    },
    uploadSubmit() {
      if (!this.classExcel) {
        this.$message.warning('请先选择文件');
        return;
      }
      const formData = new FormData();
      formData.append('file', this.classExcel);
      if (this.dialogTitle === '上传个人榜单' || this.dialogTitle === '上传团队榜单') {
        const isTeamEvent = this.dialogTitle === '上传个人榜单' ? 0 : 1;
        const leaderBoardName = this.activityStatus[this.listName];
        formData.append('leaderBoardName', leaderBoardName);
        formData.append('isTeamEvent', isTeamEvent);
        this.$Api.uara.toUaraLeaderboard(formData).then(res => {
          this.$message.success('导入成功');
          this.getList();
          this.handleCloseImport();
        });
      } else {
        formData.append('id', this.currentID);
        this.$Api.uara.upLoadTheReExaminationList(formData).then(res => {
          this.$message.success('导入成功');
          this.getList();
          this.handleCloseImport();
        });
      }
    },
    downloadFileTemplate(type) {
      let fileUrl = '';
      if (type === '上传榜单') {
        // 下载
        fileUrl = 'https://uaprd-1257321318.cos.ap-beijing.myqcloud.com/static/excel/UARA%E6%8E%92%E8%A1%8C%E6%A6%9C%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx';
      } else {
        fileUrl = 'https://uadev-1257321318.file.myqcloud.com/static/excel/e97a0168a8f304258040a13868b78ac8.xlsx';
      }
      window.open(fileUrl);
    },
    // 关闭弹窗
    handleCloseImport() {
      this.importDialogShow = false;
      this.classExcel = null;
    },
    handleSelectionChange(val) {
      this.activityIds = val.map(item => item.id);
    },
    handleSizeChange(value) {
      this.currentPage.limit = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.currentPage.current = value;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.el-tag {
  font-size: 14px;
  font-weight: 400;
}
.el-tag.el-tag--purple {
  background-color: rgba(114, 46, 209, 0.1);
  border-color: rgba(114, 46, 209, 0.7);
  color: #722ed1;
}
.el-tag.el-tag--yellow {
  background-color: rgba(234, 153, 33, 0.1);
  border-color: rgba(234, 153, 33, 0.7);
  color: #ea9921;
}
.el-tag.el-tag--blue {
  background-color: rgba(24, 144, 255, 0.1);
  border-color: rgba(24, 144, 255, 0.7);
  color: #1890ff;
}
.el-tag.el-tag--red {
  background-color: rgba(220, 0, 25, 0.1);
  border-color: rgba(220, 0, 25, 0.7);
  color: #dc0019;
}
.el-tag.el-tag--end {
  background-color: rgba(73, 73, 73, 0.1);
  border-color: rgba(155, 155, 155, 0.7);
  color: #9b9b9b;
}
.el-tag.el-tag--gray {
  background-color: rgba(73, 73, 73, 0.2);
  border-color: rgba(155, 155, 155, 0.7);
  color: #9b9b9b;
}
.button-img {
  width: 12px;
  height: 12px;
  position: absolute;
  left: 14px;
}
.upload-button {
  display: flex;
  padding-left: 30px;
  align-items: center;
  position: relative;
}
.el-dialog__wrapper {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .share-wrapper-box {
    width: 678px;
    margin: unset !important;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      max-height: calc(100vh - 6.85vh - 66px - 30px - 30px);
      overflow-y: auto;
      padding: 2.5vh 0 2.78vh 0;
      .share-form {
        padding-left: 30px;
        box-sizing: border-box;
        .el-form-item {
          display: flex;
        }
        .utmCampaign {
          margin-right: 10px;
          .el-input {
            margin-left: -8px;
          }
          .el-form-item__error {
            left: -8px;
          }
        }
        .share-form-btn {
          margin-bottom: unset;
          justify-content: center;
          margin-left: -30px;
          .el-form-item__content {
            margin-left: unset !important;
            text-align: center;
            .el-button {
              height: 4.63vh;
              line-height: 4.63vh;
              padding: 0 1.85vh;
              span {
                font-family: "Noto Sans SC";
                font-style: normal;
                font-weight: 400;
                font-size: 1.48vh;
              }
            }
          }
        }
        .info-wrapper {
          .share-form-detail {
            display: flex;
            justify-content: space-between;
            flex-wrap: nowrap;
            margin-right: 30px;
            overflow-x: hidden;
            text-overflow: ellipsis;
            .el-form-item {
              white-space: nowrap;
              span {
                margin-right: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
          .chanel {
            margin-right: 10px;
            .el-form-item__label {
              width: 108.96px;
              white-space: nowrap;
            }
          }
          .source {
            .el-form-item__label {
              width: 84.63px;
              white-space: nowrap;
            }
          }
          .split {
            width: 600px;
            height: 1px;
            background: #e3e3e5;
          }
          .info-title {
            font-family: "Noto Sans SC";
            font-style: normal;
            font-weight: 500;
            font-size: 1.44vh;
            color: #000000;
            margin: 20px 0;
          }
        }
      }
      .tabs-wrapper {
        .code-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .code-img {
            width: 13.89vh;
            height: 13.89vh;
            margin-bottom: 2.78vh;
            img {
              width: 100%;
            }
          }
          .el-button {
            height: 3.15vh;
            line-height: 3.15vh;
            padding: 0 1.85vh;
            span {
              font-family: "Noto Sans SC";
              font-style: normal;
              font-weight: 400;
              font-size: 1.48vh;
            }
          }
        }
        .link-wrapper {
          text-align: center;
          .link-content {
            text-align: left;
            height: 13.89vh;
            background: #eeeeee;
            border: 1px solid #e3e3e5;
            border-radius: 0.37vh;
            margin-bottom: 2.78vh;
            padding: 1.85vh 1.39vh;
            font-family: "Noto Sans SC";
            font-size: 1.48vh;
            line-height: 2.22vh;
            color: #000000;
            .content {
              height: 11.11vh;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .el-button {
            height: 3.15vh;
            line-height: 3.15vh;
            padding: 0 1.85vh;
            span {
              font-family: "Noto Sans SC";
              font-style: normal;
              font-weight: 400;
              font-size: 1.48vh;
            }
          }
        }
      }
    }
  }
  /deep/ .share-wrapper {
    width: 538px;
    margin: unset !important;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 30px;
      .upload-wrapTop {
        width: 100%;
        height: 114px;
        background: #f7f7f7;
        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        margin-bottom: 20px;
        padding: 20px 30px;
        > .tips {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #494949;
          margin-bottom: 20px;
        }
        > .coupon_tip {
          cursor: pointer;
          user-select: none;
          width: 130px;
          height: 34px;
          background: #ffffff;
          border: 1px solid #bbbbbb;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          line-height: 20px;
          color: #000000;
          > i {
            margin-right: 7px;
          }
        }
        > .coupon_tip:hover {
          background: #f7f7f7;
          color: #afafaf;
        }
      }
      .upload-wrap {
        width: 100%;
        height: 250px;
        background: #f7f7f7;
        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        padding: 20px 30px;
        box-sizing: border-box;
        .el-input__inner {
          height: 34px !important;
        }
        .el-upload-dragger {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .tips {
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #494949;
          margin-bottom: 20px;
        }
        .upload-box {
          width: 100%;
          height: 156px;

          .el-upload.el-upload--text {
            width: 100%;
            height: 100%;
            .el-upload-dragger {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #bbbbbb;
              border-radius: 4px;
              &:hover {
                border-color: #1c1c1c;
              }
              .file {
                line-height: 20px;
                margin-top: 5.68px;
              }
              .el-button {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    .btns {
      justify-content: center;
      margin-top: 30px;
      .el-button {
        width: 120px;
        height: 50px;
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}
</style>
